{
  "selectCompanyStep": {
    "title": "Tell us a bit more",
    "description": "Help us make your Chirpee experience as convenient as possible",
    "companyInput": {
      "label": "What is your company name?",
      "placeholder": "Enter company name"
    },
    "industryInput": {
      "label": "Company industry",
      "placeholder": "Select industry"
    },
    "dataRegion": {
      "label": "Data region",
      "placeholder": "Select data region",
      "tooltip": "This determines where your data is stored. It cannot be changed after registration.",
      "us": "United States",
      "eu": "European Union"
    },
    "nextStepButton": "Next step",
    "industries": {
      "technology": "Technology",
      "professionalServices": "Professional Services",
      "financialServices": "Financial Services",
      "consulting": "Consulting",
      "softwareDevelopment": "Software Development",
      "digitalMarketing": "Digital Marketing",
      "mediaAndCommunications": "Media and Communications",
      "eCommerce": "E-commerce",
      "healthTech": "Health Tech"
    }
  },
  "selectLanguageStep": {
    "title": "Choose workplace languages",
    "description": "Select languages, which will be supported at your workplace. You will be able to edit them later in workplace settings"
  }
}
